export default class ServerNotReachableError extends Error {
  constructor(message) {
    super(message)
    this.name = "ServerNotReachableError"
  }
}
